/* eslint-disable import/no-anonymous-default-export */
import { 
    SET_TRK_REPORT_FILTER,
    CLEAR_TRK_REPORT_FILTER,
    PURGE_TRK_REPORT_DATA,
    SET_TRK_REPORT_SECTION,
    SET_TRK_REPORT_RESOURCE,
    SET_TRK_REPORT_PRODUCT,
    SET_TRK_REPORT_PANE_SELECTED,
    SET_TRK_REPORT_SELECTED_PRODUCTS,
    SET_TRK_REPORT_SELECTED_REPORT,
    SET_TRK_REPORT_SELECTED_RESOURCES,
    SET_TRK_REPORT_SELECTED_SECTIONS,
    SET_TRK_REPORT_SELECTED_TIME,
    SET_TRK_REPORT_TIME_WINDOWS,
    SET_TRK_UPDATE_KICKER,
    SET_TRK_USER_VIEW,
    SET_TRK_REPORTS,
    SET_TRK_SESSIONS,
    STORE_TRK_FLTR_SECTIONS,
    STORE_TRK_FLTR_RESOURCES,
    STORE_TRK_FLTR_PRODUCTS,
    RESET_TRK_FLTRS,
    SET_CURRENT_TASK_ROW,
    SET_TRK_IS_LOADING,
    SET_TRK_SITREP,
} from '../actions/_types'

const initialState = {
    filter: [],
    update: false,
    paneSelected: 'TASKS', // 'TASKS', 'BALANCE', 'LABORCODES'
    userView: true,
    rptGrid: {
        byProduct: {
            tasks: [],
            balances: [],
            laborCodes: [],
        },
        byResource: {
            tasks: [],
            balances: [],
            laborCodes: [],            
        },
        bySection: {
            tasks: [],
            balances: [],
            laborCodes: [],
        }
    },
    sections: [],
    resources: [],
    products: [],
    timeWindows: [],
    resetFilter: false, // selection kicker for selected section, resource, product
    selected: {
        sections: null,
        resources: null,
        products: null,
        timeWindow: {},
        report: {}
    },
    reports: [],
    sessions: [],
    sitReps: [],
    currentTaskRow: {},
    isLoading: {loading: false, msg: ''}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_TRK_REPORT_FILTER:
            return { ...state, filter: action.payload };
        case CLEAR_TRK_REPORT_FILTER:
            return { ...state, filter: initialState.filter };
        case SET_TRK_SESSIONS:
            return { ...state, sessions: action.payload};
        case PURGE_TRK_REPORT_DATA:
            return { ...initialState };            
        case SET_TRK_REPORT_SECTION:
            return { ...state, rptGrid: {...state.rptGrid, bySection: action.payload}};
        case SET_TRK_REPORT_RESOURCE:
            return { ...state, rptGrid: {...state.rptGrid, byResource: action.payload}};
        case SET_TRK_REPORT_PRODUCT:
            return { ...state, rptGrid: {...state.rptGrid, byProduct: action.payload}};
        case SET_TRK_REPORT_PANE_SELECTED: 
            return { ...state, paneSelected: action.payload};
        case SET_TRK_REPORT_SELECTED_PRODUCTS: 
            return { ...state, selected: {...state.selected, products: action.payload}};
        case SET_TRK_REPORT_SELECTED_REPORT: 
            return { ...state, selected: {...state.selected, report: action.payload}};
        case SET_TRK_REPORT_SELECTED_RESOURCES: 
            return { ...state, selected: {...state.selected, resources: action.payload}};
        case SET_TRK_REPORT_SELECTED_SECTIONS: 
            return { ...state, selected: {...state.selected, sections: action.payload}};
        case SET_TRK_REPORT_SELECTED_TIME: 
            return { ...state, selected: {...state.selected, timeWindow: action.payload}};   
        case SET_TRK_REPORT_TIME_WINDOWS: 
            return { ...state, timeWindows: action.payload};
        case SET_TRK_UPDATE_KICKER:
            return {...state, update: action.payload};
        case SET_TRK_USER_VIEW:
            return {...state, userView: action.payload};
        case SET_TRK_REPORTS:
            return {...state, reports: action.payload};
        case STORE_TRK_FLTR_PRODUCTS:
            return {...state, products: action.payload};
        case STORE_TRK_FLTR_RESOURCES:
            return {...state, resources: action.payload};
        case STORE_TRK_FLTR_SECTIONS:
            return {...state, sections: action.payload};    
        case RESET_TRK_FLTRS:
            return {...state, resetFilter: action.payload};
        case SET_CURRENT_TASK_ROW:
            return {...state, currentTaskRow: action.payload};
        case SET_TRK_IS_LOADING:
            return {...state, isLoading: action.payload}  
        case SET_TRK_SITREP: 
            return {...state, sitReps: action.payload}                                  
        default:
            return state
    }
};
